/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Player color
 */
export interface PlayerColor { 
    /**
     * Player number
     */
    playerNumber: number;
    /**
     * Color
     */
    color: PlayerColor.ColorEnum;
}
export namespace PlayerColor {
    export type ColorEnum = 'BLUE' | 'GREEN' | 'YELLOW' | 'RED' | 'PURPLE';
    export const ColorEnum = {
        BLUE: 'BLUE' as ColorEnum,
        GREEN: 'GREEN' as ColorEnum,
        YELLOW: 'YELLOW' as ColorEnum,
        RED: 'RED' as ColorEnum,
        PURPLE: 'PURPLE' as ColorEnum
    };
}